import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ConfigService } from '../config.service';
import { TaskType } from '../shared/enums/task.enum';

/**
 * Keeps the upload tasks page closed without the `case_uploader` feature (the upload endpoints are disabled then).
 * An upload url is redirected to `/tasks`, which opens the reader tasks.
 *
 * The page is one route for all the task types, so the guard runs again when the `taskType` param changes
 * (the default `runGuardsAndResolvers: 'paramsChange'`).
 */
export const taskTypeRouteGuard: CanActivateFn = async (route) => {
  // inject before the first await, the injection context ends there
  const config = inject(ConfigService);
  const router = inject(Router);
  // the feature flags come with the api config
  await config.loadApiConfig();

  if (route.params.taskType === TaskType.Upload && !config.isFeatureEnabled('case_uploader')) {
    return router.createUrlTree(['tasks']);
  }
  return true;
};
